<template>
  <UiContainer tag="header" class="py-4.5">
    <div class="relative z-20 flex items-center justify-between">
      <h1 class="text-3xl font-bold">Все категории</h1>
      <button v-if="smallHeader" type="button" class="pr-4" @click="toggleHideHeader(false)">
        <UiIcon name="three-dots" class="size-6 text-text-main" />
      </button>
    </div>
    <ul
      v-if="categoriesNav"
      :class="{ '!absolute -translate-y-full opacity-0': smallHeader }"
      class="z-10 mt-2 flex flex-wrap gap-1.5 transition-all duration-500"
    >
      <li v-for="category in categoriesNav" :key="category.id">
        <UiButton
          severity="secondary"
          :tag="AppRouterLink"
          :to="{ name: 'CategoryItemView', params: { id: category.id } }"
          class="block first-letter:lowercase"
        >
          <span class="relative">{{ category.name }}</span>
        </UiButton>
      </li>
    </ul>
  </UiContainer>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useConfiguration } from '@/5_entities/Configuration'
import { useHiddenHeader } from '@/6_shared/composables'
import { AppRouterLink, UiButton, UiContainer, UiIcon } from '@/6_shared/ui'

const { categoriesNav } = storeToRefs(useConfiguration())
const { smallHeader, toggleHideHeader } = useHiddenHeader()
</script>
